/* eslint-disable */
import request from './helpers'

export function listVersion (secretId, stageType) {
    return request({
        url: '/backend/secret/listVersions',
        method: 'get',
        params: {
            secretId, stageType
        }
    })
}

export function addVersion (data) {
    return request({
        url: '/backend/secret/addVersion',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function updateToCurrent (data) {
    return request({
        url: '/backend/secret/updateToCurrent',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function revokeVersion (data) {
    return request({
        url: '/backend/secret/revokeVersion',
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
